import stringToHslColor from '@jimmyboys/liita-ui/dist/utils/stringToHslColor'
import { i18n } from 'localization'
import moment from 'moment/moment'

export default class User {
	static fromJSON(json) {
		return new User(json.id)
			.withName(json.fullName)
			.withRoles(json.roles)
			.withAvatar(json.fullName)
			.withUnavailability(json.unavailability)
			.withLink(json.id)
			.withExternalId(json.legacyId)
			.withUsername(json.username)
	}

	constructor(id) {
		this.id = id
	}

	withName(name) {
		this.name = name
		return this
	}

	withRoles(roles) {
		this.roles = roles.map((role) => ({
			id: role.toLowerCase(),
			name: i18n.translate(role),
		}))
		this.isAdmin = this.roles.some((item) => item.id === 'admin')
		return this
	}

	withUnavailability(unavailability) {
		this.unavailability = {
			...unavailability,
			willBeUnavailable:
				moment().diff(
					moment(
						new Date(
							(unavailability?.endDate?.seconds?.low ??
								unavailability?.endDate?.seconds) * 1000
						)
					)
				) < 0,
		}

		return this
	}

	withAvatar(name) {
		let firstName = ''
		let remainingNames = ['']
		name = (name || '')
			.trim()
			.replace(/^dra?.?,?(\s+)?|,?(\s+)?dra?.?$/gi, '')

		if (name) {
			;[firstName, ...remainingNames] = (name || '').split(' ')
		}

		const initials = `${firstName && firstName[0] ? firstName[0] : ''}${
			remainingNames && remainingNames[remainingNames.length - 1]?.[0]
				? remainingNames[remainingNames.length - 1]?.[0]
				: ''
		}`
		const backgroundColor = stringToHslColor(initials)

		this.avatar = {
			initials,
			backgroundColor,
		}

		return this
	}

	withLink(id) {
		if (id) {
			this.link = {
				to: `/users/${id}/user-exclusion/`,
				name: i18n`See User`,
			}
		}
		return this
	}

	withExternalId(externalUserId) {
		this.externalUserId = externalUserId
		return this
	}

	withUsername(username) {
		this.username = username
		return this
	}
}
